import FeedbackPage from '@/components/FeedbackPage'
import { UserGroupIcon } from '@heroicons/react/24/outline'

export default function SocialLifeIntroPage() {
  return (
    <FeedbackPage
      icon={<UserGroupIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.socialLifeIntro.heading"
      descriptionKey="pages.onboarding.socialLifeIntro.description"
    />
  )
}
